import { render } from "./PopUpChangePassword.vue?vue&type=template&id=fd7da780&scoped=true"
import script from "./PopUpChangePassword.vue?vue&type=script&lang=js"
export * from "./PopUpChangePassword.vue?vue&type=script&lang=js"

import "./PopUpChangePassword.vue?vue&type=style&index=0&id=fd7da780&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd7da780"]])

export default __exports__